var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.doc)?_c('v-row',{attrs:{"align":"center"}},[_c('v-col',{attrs:{"cols":"auto"}},[_c('v-icon',{attrs:{"size":"20"},domProps:{"textContent":_vm._s(_vm.icon)}})],1),_c('v-col',[_c('a',{attrs:{"href":_vm.doc.url,"download":"","target":"_blank"}},[_vm._v(_vm._s(_vm.doc.name))])])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }